import React from "react";
import { Link } from "react-router-dom";
import { routes } from "../data/business";
import { SkylineSilhouette } from "./brand/SkylineSilhouette";
import { BailHelpForm } from "./forms/BailHelpForm";
import { MagneticCallButton } from "./ui/MagneticCallButton";
import { buttonStyles } from "./ui/buttonStyles";
type FinalCtaBandProps = {
  title?: React.ReactNode;
  subtitle?: string;
  showForm?: boolean;
  formSubject?: string;
};
export function FinalCtaBand({
  title = <>
      You don't have to figure this out <em className="text-gold-soft" data-id="element-81" data-mp="1cug462qte0px">alone.</em>
    </>,
  subtitle = "Call now — we answer 24/7.",
  showForm = true,
  formSubject
}: FinalCtaBandProps) {
  return <section aria-labelledby="final-cta-title" className="grain relative overflow-hidden bg-navy text-white" data-id="element-82" data-mp="1msdr8mwxtrgy">
      <div className="gold-glow pointer-events-none absolute left-[10%] top-0 h-[40rem] w-[40rem]" aria-hidden="true" data-id="element-83" data-mp="2t8ptp06slvic" />
      <div className={`gutter relative grid gap-[clamp(3rem,6vw,8rem)] pb-[clamp(9rem,14vw,14rem)] pt-[clamp(5rem,10vw,10rem)] ${showForm ? "lg:grid-cols-2" : ""}`} data-id="element-84" data-mp="2y5g5vcfh86yh">
        <div className={showForm ? "" : "mx-auto max-w-4xl text-center"} data-id="element-85" data-mp="1tkeicveo6cxc">
          <p className="eyebrow text-gold-soft" data-id="element-86" data-mp="1oluwev02t14z">We're here right now</p>
          <h2 id="final-cta-title" className={`mt-5 max-w-[14ch] font-serif text-[clamp(2.5rem,5vw,5.5rem)] font-normal leading-[1.04] tracking-[-0.02em] ${showForm ? "" : "mx-auto"}`} data-id="element-87" data-mp="1ok0e7og6vn4l">
            {title}
          </h2>
          <p className="mt-6 text-xl text-white/75" data-id="element-88" data-mp="1epi33y8g0par">{subtitle}</p>
          <div className={`mt-10 flex flex-col gap-4 sm:flex-row sm:items-center ${showForm ? "" : "justify-center"}`} data-id="element-89" data-mp="19ve01q2at1ey">
            <MagneticCallButton size="xl" data-id="element-90" data-mp="15t93aigjzoo3" />
            <Link to={routes.getBond} className={buttonStyles.outlineLight} data-id="element-91" data-mp="10x1yiszw8j7q">
              Start Online
            </Link>
          </div>
        </div>
        {showForm && <div className="glass rounded-3xl p-[clamp(1.5rem,3vw,2.75rem)] shadow-glass" data-id="element-92" data-mp="qycqrt1pof57">
            <h3 className="font-serif text-3xl" data-id="element-93" data-mp="hagw6v8okknd">Request a call back</h3>
            <p className="mt-2 text-white/70" data-id="element-94" data-mp="h95tyzuvvkyd">Tell us a little, and we'll call you right away.</p>
            <div className="mt-8" data-id="element-95" data-mp="mav5egm0q0mz">
              <BailHelpForm defaultSubject={formSubject} data-id="element-96" data-mp="8a28jp88utgp" />
            </div>
          </div>}
      </div>
      <SkylineSilhouette className="pointer-events-none absolute inset-x-0 bottom-0 h-[clamp(5rem,9vw,9rem)] w-full" data-id="element-97" data-mp="cauhsih48ycz" />
    </section>;
}